import * as R from "ramda";
function mapPublicProfileResult(publicProfile) {
    const name = R.pathOr(undefined, ["name", "value"], publicProfile);
    const image = R.pathOr(undefined, ["image", "value"], publicProfile);
    const headline = R.pathOr(undefined, ["headline", "value"], publicProfile);
    const verified = false;
    return {
        name: name ? { value: name, verified } : undefined,
        image: image ? { url: image, verified } : undefined,
        headline: headline ? { value: headline, verified } : undefined,
    };
}
export default {
    mapPublicProfileResult,
};
